// extracted by mini-css-extract-plugin
export default {"form":"CalendarEventModal_form__J8wCa","switchField":"CalendarEventModal_switchField__kssL+","hint":"CalendarEventModal_hint__svWwX","actions":"CalendarEventModal_actions__71X4C"};